module.exports = __webpack_public_path__ + "static/img/emptyorder.96f05dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/emptyorder.png
// module id = QdL1
// module chunks = 1